import React, { useState, useContext, useCallback, useMemo } from 'react';

export const RecoveryContext = React.createContext();

export const useRecovery = () => {
  const context = useContext(RecoveryContext);
  return context;
};

export const RecoveryProvider = ({ children }) => {
  const [context, setContext] = useState({
    username: '',
    code: '',
    email: '',
  });

  const handleUsername = useCallback(
    username => {
      setContext(x => ({ ...x, username }));
    },
    [setContext],
  );

  const handleCode = useCallback(
    code => {
      setContext(x => ({ ...x, code }));
    },
    [setContext],
  );

  const handleEmail = useCallback(
    email => {
      setContext(x => ({ ...x, email }));
    },
    [setContext],
  );

  const handleClear = useCallback(() => {
    setContext(() => ({
      username: '',
      code: '',
      email: '',
    }));
  }, [setContext]);

  const value = useMemo(
    () => ({
      username: context.username,
      code: context.code,
      email: context.email,
      setUsername: handleUsername,
      setCode: handleCode,
      setEmail: handleEmail,
      clear: handleClear,
    }),
    [context, handleUsername, handleCode, handleEmail, handleClear],
  );

  return <RecoveryContext.Provider value={value}>{children}</RecoveryContext.Provider>;
};
